import Platform from '../Platform'
import Storage from './Storage'

export default class App extends Platform {
  constructor() {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      supportedInsertFileTypes: ['svg'],
      storage: new Storage(),
      features: {
        localStorage: false,
        prototype: true,
        messages: false,
        fillType: true,
        syncFromTool: true
      }
    })
  }

  // file = { format, name, url }
  insertItem(file) {
    console.log('insertItem', file)
    if (file.format === 'svg') {
      window.postMessage('insertSVG', file)
    } else {
      window.postMessage('insertRaster', file)
    }
  }

  insertItems(files) {
    console.log('insertItems', files)
    if (files[0].format === 'svg') {
      window.postMessage('insertSVGs', files)
    } else {
      window.postMessage('insertRasters', files)
    }
  }

  showMessage({ message }) {
    window.postMessage('showMessage', message)
  }

  openURL(url) {
    window.postMessage('openURL', url)
  }

  // Myscout
  syncSelection(uuid, token) {
    // const endpoint = routeGenerator('syncComponent', { folder: uuid })
    const endpoint = process.env.VUE_APP_API_SYNC_COMPONENT || process.env.NUXT_ENV_API_SYNC_COMPONENT
    window.postMessage('syncComponents', {
      endpoint,
      token,
      data: {
        uuid
      }
    })
  }

  getAllSelectionColors() {
    window.postMessage('getAllSelectionColors')
  }

  fillColor(color) {
    window.postMessage('fillColor', color)
  }

  fillBorderColor(color) {
    window.postMessage('fillBorderColor', color)
  }

  addToDocumentColor (color) {
    window.postMessage('addToDocumentColor', color)
  }
}
